import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.OCORRENCIA.SET_INFORMACOES_OCORRENCIA](state, informacoes) {
		state.informacoesOcorrencia = informacoes
	},

	[mutationTypes.OCORRENCIA.SET_INFORMACOES_ITENS_OCORRENCIA](state, informacoes) {
		state.informacoesItens = informacoes
	},
	[mutationTypes.OCORRENCIA.SET_KEY_LISTAR_OCORRENCIAS](state) {
		state.atualizaListagem++
	},
}
